/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VoucherDto } from '../../models/voucher-dto';

export interface CenterVoucherControllerFindAll$Params {
  centerId?: string;
}

export function centerVoucherControllerFindAll(http: HttpClient, rootUrl: string, params?: CenterVoucherControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VoucherDto>>> {
  const rb = new RequestBuilder(rootUrl, centerVoucherControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VoucherDto>>;
    })
  );
}

centerVoucherControllerFindAll.PATH = '/api/voucher/center';
